import React from 'react';
import style from '../Footer/Footer.module.css';


import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {

  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 80,  // Adjust the offset to match your navbar height
          behavior: 'smooth',
        });
      }
    }, 10);
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    navigate('/');
    scrollToSection('HOME_SECTION');
    showCustomAlert('Navigated to Home Section');
  };

  const handleAboutUsClick = (e) => {
    e.preventDefault();
    navigate('/');
    scrollToSection('ABOUT_SECTION');
    showCustomAlert('Navigated to About Us');
  };

  const handleContactUsClick = (e) => {
    e.preventDefault();
    navigate('/');
    scrollToSection('Contact_Us');
    showCustomAlert('Navigated to Contact Us');
  };

  const handleServicesClick = (e) => {
    e.preventDefault();
    navigate('/');
    scrollToSection('Service_s');
    showCustomAlert('Navigated to Services');
  };




  const showCustomAlert = (message) => {
    const alertBox = document.createElement('div');
    alertBox.innerText = message;
    alertBox.style.position = 'fixed';
    alertBox.style.top = '5%';
    alertBox.style.left = '50%';
    alertBox.style.transform = 'translate(-50%, -50%)';
    alertBox.style.padding = '10px 20px';
    alertBox.style.backgroundColor = '#4CAF50';
    alertBox.style.color = 'white';
    alertBox.style.fontSize = '16px';
    alertBox.style.borderRadius = '5px';
    alertBox.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
    alertBox.style.zIndex = '9999';


  };




  return (
    <>
      <div className={style.footercontainer}>
        <hr />
        <div className={`container`}>
          <div className={` row ${style.therow} `} id="footer_row">
            <div className={`col-md-3 ${style.footerCol}`}>


              <a className={style.footerLink} href="/home" onClick={handleHomeClick} >Home</a>



              <a className={style.footerLink} href="/Aboutus" onClick={handleAboutUsClick}>About</a>

            </div>

            <div className={`col-md-3 ${style.footerCol}`}>



              <a className={style.footerLink} href="/Contactus" onClick={handleContactUsClick}>Contact Us</a>




              <a className={style.footerLink} href="/Servicespage" onClick={handleServicesClick} >Services</a>

            </div>
            <div className={`col-md-3 ${style.footerCol}`}>


              <Link to={"/Log_in"} className={style.footerLink}>
                Login
              </Link>


              <Link to={"/Sign_up"} className={style.footerLink}>
                Sign-up
              </Link>


            </div>


            <div className={`col-md-3 ${style.footerCol}`}>

              <Link to={"/terms_services"} className={style.footerLink}> Terms & Conditions </Link>



              <Link to={"/privacy_policy"} className={style.footerLink}>
                Privacy Policy
              </Link>


            </div>


          </div>
        </div>
        <hr />
        <div className={style.footerBottom}>
          <p className={style.creditText}>
            Developed By: Integration IT Services Pvt. Ltd.
          </p>
        </div>
      </div>
    </>
  );
}
